import pxToRem from 'src/theme/functions/pxToRem';

import colors from 'src/theme/base/colors';
import boxShadows from 'src/theme/base/boxShadows';
import borders from 'src/theme/base/borders';

const { transparent } = colors;
const { lg } = boxShadows;
const { borderRadius } = borders;

const popover = {
  styleOverrides: {
    paper: {
      backgroundColor: transparent.main,
      boxShadow: lg,
      padding: pxToRem(8),
      borderRadius: borderRadius.lg,
    },
  },
};

export default popover;
